import { React, useContext, useEffect, useState, useCallback } from "react"
import { Geolocation } from "@capacitor/geolocation"
import { useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormControl from "@mui/material/FormControl"
import TextField from "@mui/material/TextField"
import FormLabel from "@mui/material/FormLabel"
import { useForm, Controller } from "react-hook-form"
import { Preferences } from "@capacitor/preferences"
import { CommonContext } from "../contexts/CommonContext"
import { motion } from "framer-motion"
import {
  addNewAddress,
  getAllUserAddress,
  getBranchInfo,
  getDeliveryCharge,
  getDynamicDeliveryCharge,
  getNearestStoreDetails,
  getPilotBranchInfo,
  getStockAvailability,
  getUserDeliveryData,
  logAction,
  // getStoreFromPods,
} from "../services/api"
import { getFirebaseError } from "../services/error-codes"
import { AuthContext } from "../contexts/AuthContext"
import ComponentLoader from "../components/ComponentLoader"
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
} from "@react-google-maps/api"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import { Capacitor } from "@capacitor/core"
import NavHeader from "../components/NavHeader"
import { useLocation } from "react-router-dom"
import { BorderBottom } from "@mui/icons-material"
import AddIcon from "../assets/add-icon-delivery.png"
import DeliveryClose from "../assets/delivery-close.png"
import TimeSlot from "../assets/timeslot.png"
const styles = {
  titleCont: {
    fontSize: "25px",
    marginBottom: "10px",
    fontFamily: "Foregen",
    color: "#404040",
    textDecoration: "underline",
    textDecorationColor: "#a4243d",
  },
}

const placesLibrary = ["places"]

const GEO_OPTIONS = { enableHighAccuracy: true, timeout: 10000, maximumAge: 10000 }

function Delivery() {
  const containerStyle = {
    width: "100%",
    height: "400px",
  }

  const navigate = useNavigate()

  const [showNewAddress, setShowNewAddress] = useState(false)
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm()
  const { showLoader, hideLoader, showAlert, showSnackbar, cartData, isDesktop } =
    useContext(CommonContext)
  const { getUserId, logout } = useContext(AuthContext)
  const [newAddressDetail, setNewAddressDetail] = useState({})
  const [deliveryAddress, setDeliveryAddress] = useState(null)
  const [paymentMode, setPaymentMode] = useState("online")
  const { getCartData } = useContext(CommonContext)
  const [loading, setLoading] = useState(true)
  const [address, setAddress] = useState([])
  const [latLong, setLatLong] = useState({})
  const location = useLocation()
  const [searchResult, setSearchResult] = useState("Result: none")
  const [isLocating, setIsLocating] = useState(false)

  const [selectedAddrIndex, setSelectedAddrIndex] = useState(null)

  const [delSlot, setDelSlot] = useState("")
  const [delType, setDelType] = useState("delivery")
  const [delDate, setDelDate] = useState("Today")
  const [storeDetails, setStoreDetails] = useState("")
  const [map, setMap] = useState(null)
  const [enableSelfPickup, setEnableSelfPickup] = useState(false)

  const [allDeliverySlots, setAllDeliverySlots] = useState([])
  const [filteredSlots, setFilteredSlots] = useState([])
  const [deliveryCharge, setDeliveryCharge] = useState({ charge: 0, distance: null })
  const [hasCoupon, setHasCoupon] = useState(false)
  const [stockMap, setStockMap] = useState({})

  const onDelDateChange = (event, newDate) => {
    setDelSlot(null)
    setDelDate(newDate)
    if (selectedAddrIndex !== null) {
      showLoader()
      fetchBranchInfo(newDate, storeDetails)
    }
  }

  const changeDeliverySlot = (newSlot) => {
    setDelSlot(newSlot)
  }

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_MAP_KEY,
    libraries: placesLibrary,
  })

  const fetchDeliveryCharge = async () => {
    const cartTotal = cartData?.totalAmount || 0
    const couponData = await Preferences.get({ key: "couponData" })
    if (couponData.value) {
      if (
        JSON.parse(couponData.value).couponCode == "HEALTHYEATS" ||
        JSON.parse(couponData.value).couponCode == "HEALTHYEGGS"
      ) {
        setHasCoupon(true)
      }
    }

    // Self pickup is always free
    if (delType === "self_pickup") {
      setDeliveryCharge({ charge: 0, distance: null })
      return
    }

    // Use dynamic delivery charge (backend) when we have address + store details
    const customerLat = deliveryAddress?.latLong?.lat
    const customerLng = deliveryAddress?.latLong?.lng
    const storeBranchId = storeDetails?.branchId

    if (customerLat && customerLng && storeBranchId && delType === "delivery") {
      try {
        const result = await getDynamicDeliveryCharge({
          customerLat,
          customerLng,
          storeBranchId,
          cartTotal,
          deliveryType: delType,
        })
        setDeliveryCharge({ charge: result.charge, distance: result.distance })
      } catch (error) {
        console.error("Dynamic delivery charge failed, using fallback:", error)
        const fallback = await getDeliveryCharge("delivery", storeDetails, cartTotal)
        setDeliveryCharge({ charge: fallback, distance: null })
      }
    } else {
      const charge = await getDeliveryCharge(delType || "delivery", storeDetails, cartTotal)
      setDeliveryCharge({ charge, distance: null })
    }
  }

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])

  const onLoad = useCallback(function callback(mapInstance) {
    setMap(mapInstance)
    const defaultCenter = { lat: 17.38714, lng: 78.491684 }
    mapInstance.setCenter(defaultCenter)
    mapInstance.setZoom(17)
    Geolocation.getCurrentPosition(GEO_OPTIONS)
      .then((resp) => {
        const newPos = {
          lat: resp.coords.latitude,
          lng: resp.coords.longitude,
        }
        window["currentLocation"] = newPos
        setLatLong(newPos)
        mapInstance.setCenter(newPos)
        mapInstance.setZoom(17)
      })
      .catch(() => {
        window["currentLocation"] = defaultCenter
        setLatLong(defaultCenter)
      })
  }, [])

  const mapPositionChanged = (e) => {
    setLatLong({
      lat: e.lat(),
      lng: e.lng(),
    })
  }

  function onAutoCompleteLoad(autocomplete) {
    setSearchResult(autocomplete)
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      const place = searchResult.getPlace()
      window["currentLocation"] = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      setLatLong(window["currentLocation"])
    } else {
      showAlert("Please enter address for map", "error")
    }
  }

  useEffect(() => {
    logAction("PAGE_VIEW", "delivery")
    getUserAddress()
    window["currentLocation"] = { lat: 17.38714, lng: 78.491684 }
  }, [])

  useEffect(() => {
    if (address && address.length > 0) {
      handleAddressChange({ target: { value: 0 } })
    }
  }, [address])

  // Refetch delivery charge when address, store, delivery type, or cart changes
  useEffect(() => {
    fetchDeliveryCharge()
  }, [storeDetails, deliveryAddress, delType, cartData?.totalAmount])

  const printCurrentPosition = async () => {
    setIsLocating(true)
    await Geolocation.getCurrentPosition(GEO_OPTIONS)
      .then((resp) => {
        const newPos = {
          lat: resp.coords.latitude,
          lng: resp.coords.longitude,
        }
        setLatLong(newPos)
        window["currentLocation"] = newPos
        if (map) {
          map.setCenter(newPos)
          map.setZoom(17)
        }
      })
      .catch((err) => {
        requestForLocPermission()
      })
      .finally(() => {
        setIsLocating(false)
      })
  }
 
  // Function to format the time slot
  
  const formatTimeSlot = (timeString) => {
    const [startTime, endTime] = timeString.split(" - ");
  
    const formatTime = (time) => {
      // Split time into hours, minutes, and period
      const [hours, minutes, period] = time
        .match(/(\d+):(\d+)\s*(AM|PM)/)
        .slice(1);
  
      // Remove leading zeros and combine
      return `${parseInt(hours)} ${period}`;
    };
  
    const formattedStart = formatTime(startTime);
    const formattedEnd = formatTime(endTime);
  
    // Recombine the formatted times
    return `${formattedStart} - ${formattedEnd}`;
  };
  

  const requestForLocPermission = async () => {
    await Geolocation.requestPermissions("location")
      .then((resp) => {
        if (resp.location == "granted") printCurrentPosition()
        else
          showAlert(
            "Location permission is disabled. Please enable location to continue"
          )
      })
      .catch((err) => {
        showAlert(
          "Location permission is disabled. Please enable location to continue"
        )
      })
  }

  const getUserAddress = async () => {
    getUserDeliveryData(await getUserId())
      .then((response) => {
          // Sort addresses by timestamp in descending order
          const sortedAddresses = response.addresses.sort((a, b) => b.timeStamp - a.timeStamp)
          setAddress(sortedAddresses)
        
          setLoading(false)
      })
      .catch((error) => {
        // setLoading(false)
        logout()
        showAlert(
          "Unexpected error occured. For any issues/enquiries please contact customer care"
        )
      })
  }

  const onFormSubmit = async (data) => {
    data.houseDetails = data.houseDetails.replace("'", "")
    data.landmark = data.landmark.replace("'", "")
    data.streetDetails = data.streetDetails.replace("'", "")

    data.userId = await getUserId()
    data.timeStamp = Date.now()
    data.latLong = latLong

    if (!latLong.lat || !latLong.lng) {
      showAlert("Please select your delivery location on map to add address.")
      return
    }

    showLoader()
    addNewAddress(data, false)
      .then((response) => {
        getUserAddress()
        hideLoader()
      })
      .catch((error) => {
        hideLoader()
        showAlert(getFirebaseError(error))
      })

    reset()
    setShowNewAddress(false)
  }

  const closeAddNewAddrForm = async () => {
    setShowNewAddress(false)
    reset()
  }

  const changeDeliveryType = (e) => {
    setDelType(e.target.value)
    setPaymentMode("online")
  }
  const PaymentOption = ({ value, label, isSelected, extraText }) => (
    <FormControlLabel
      value={value}
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        fontFamily:'RobotSlab',
        borderRadius: "7px",
        width: "100%",
        flex: 1, // Equal width for buttons
        // padding: "5px",
        background: isSelected ? "#a4243d" : "none",
        color: isSelected ? "#FFF5E8" : "#2c2c2c",
        border: isSelected ? "none" : "1px solid #2c2c2c",
        transition: "background 0.3s",
        marginRight: "0px !important",
      }}
      control={
        <Radio
          sx={{
            color: "#2c2c2c",
            margin: "2px",
            "&.Mui-checked": {
              color: "#FFF5E8",
            },
          }}
        />
      }
      label={
        <Box
          sx={{
            fontSize: "12px",
            width: "100%",
            fontWeight: "500",
            // padding: "2px",
            marginRight: "15px !important",
          }}
        >
          {label}
          {extraText && (
            <Box
              sx={{
                fontSize: "8px",
                color: isSelected ? "#FFF5E8" : "#2c2c2c",
              }}
            >
              {extraText}
            </Box>
          )}
        </Box>
      }
    />
  )

  const confirmOrder = async () => {

    if (!deliveryAddress) {
      showSnackbar("Please select an address to continue", "error")
      return
    }
    
    if (!delType) {
      showSnackbar("Please select a delivery type", "error");
      return;
    }
  
    if (!delSlot) {
      showSnackbar("Please select a delivery slot", "error")
      return
    }

    if (!delDate) {
      showSnackbar("Please select a delivery date", "error")
      return
    }

    if (!paymentMode) {
      showSnackbar("Please select a payment mode", "error")
      return
    }

    const cartData = await getCartData()
    let isOOS = false
    //Checking stock availability
    Object.keys(cartData).forEach((item) => {
      if (stockMap[item] == "off") {
        const alertMsg = `
 We're sorry, but the item ${cartData[item].name} just went out of stock. We will notify you as soon as it is available again. Thank you for your understanding!`
        showAlert(alertMsg)
        isOOS = true
      }
    })

    if (isOOS) return

    let selectedSlot = filteredSlots.filter(
      (slot) => slot.id == delSlot
    )[0]
    const summaryProps = {
      addressDetails: deliveryAddress,
      paymentMode: paymentMode,
      delSlotId: selectedSlot.pranaSlotId || selectedSlot.id,
      delDate: delDate,
      timeSlotId : delSlot,
      delSlotTime: selectedSlot.displayTime,
      delType: delType,
      storeDetails: storeDetails,
      itemDetails: cartData,
      instructions: location?.state?.instructions,
      customerLat: deliveryAddress?.latLong?.lat,
      customerLng: deliveryAddress?.latLong?.lng,
      deliveryCharge: deliveryCharge,
      timeSlotDetails : {
        startTime : selectedSlot.startTime,
        endTime : selectedSlot.endTime,
        slotId : selectedSlot.id,
        active : selectedSlot.active
      }  
    }
    console.log("summaryProps", summaryProps)
    navigate(`/orderSummary`, { state: summaryProps, replace: true })
  }

  // const checkLocationInPods = async (event) => { 
  //   try {
  //     if (address[event.target.value].latLong) {
  //       const podsResponse = await getStoreFromPods(address[event.target.value].latLong)
  //       return podsResponse
  //     }
  //   } catch (error) {
  //     // You might want to handle the error gracefully without showing it to the user
  //   }
  // }



const handleAddressChange = async (event) => {
  showLoader()

  // Always call getNearestStoreDetails API to ensure fresh store allocation
  // This prevents issues with cached wrong store allocations from previous pods implementation
  const resp = await getNearestStoreDetails(address[event.target.value])

  if (!resp.branchId || !resp.locCode) {
    showAlert(
      <>
        <b>
          We regret to inform you that delivery is not available for the
          selected address.
        </b>
        <br />
        <br /> Please note that we deliver within a maximum radius of 8km
        and the selected address lies beyond our delivery range.
      </>
    )
    hideLoader()
    return
  }

  modifyPickupStatus(resp)
  setStoreDetails(resp)

  // Update address with fresh store details
  address[event.target.value].storeDetails = {
    branchId: resp.branchId,
    locCode: resp.locCode,
    storeName: resp.storeName,
    ...resp // Include all response data
  }
  
  await fetchBranchInfo("Today", resp)

  getStockAvailability({
    storeId: resp.branchId,
  }).then((response) => {
    setStockMap(response)
    hideLoader()
  })

  setSelectedAddrIndex(event.target.value)
  setDeliveryAddress(address[event.target.value])
}
  // const fetchStockInfo = async (branchId) => {
  //   try {
  //     const stockResponse = await getStockAvailability({ storeId: branchId })
  //     setStockMap(stockResponse)
  //   } catch (error) {
  //     setStockMap({})
  //   }
  // }
  
  const modifyPickupStatus = (storeDetails) => {
    // Self-pickup disabled - only home delivery available
    setEnableSelfPickup(false)
    setDelType("delivery")
  }

  const fetchBranchInfo = async (deliveryDate, store) => {

    let branchInfo

    console.log("Getting Branch Info for Store", store)

    branchInfo = await getPilotBranchInfo({
      userId: await getUserId(),
      branchId: store.branchId,
      deliveryDate: deliveryDate,
      timeStamp: Date.now(),
      storeId: store.storeId,
      podId: store.podId,
      cartData: Object.keys(await getCartData()),
    })

    // branchInfo = await getBranchInfo({
    //   userId: await getUserId(),
    //   branchId: store.branchId,
    //   deliveryDate: deliveryDate,
    //   timeStamp: Date.now(),
    //   storeId: store.storeId,
    //   cartData: Object.keys(await getCartData()),
    // })

    setFilteredSlots(branchInfo.slots)
    setDelSlot("")
    setDelDate(deliveryDate)
    hideLoader()
  }

  const handlePaymentChange = async (event) => {
    setPaymentMode(event.target.value)
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Box sx={{ maxWidth: "700px", marginTop: isDesktop ? "14vh" : "7vh", marginLeft: isDesktop ? '50px' : "" }}>
        {loading ? (
          <ComponentLoader />
        ) : (
          <Box>
            <Box sx={{ padding:"0px 20px" }}>
              <NavHeader />
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box style={styles.titleCont}>Delivery Details</Box>
                  <Box>
                    <img
                      src={DeliveryClose}
                      onClick={() => navigate(-2)}
                      alt="Close"
                    />
                  </Box>
                </Box>
                <Box sx={{ fontFamily: "RobotoSlabBold" }}>Address</Box>

                <RadioGroup
                  onChange={handleAddressChange}
                  value={selectedAddrIndex}
                >
                  {address.map((address, index) => {
                    return (
                      <Box key={index}>
                        <Box
                          sx={{
                            padding: "10px",
                            margin: "5px 0",
                            background: "rgba(164, 36, 61, 0.1)",
                            borderRadius: "5px",
                          }}
                        >
                          <FormControlLabel
                            value={index}
                            control={
                              <Radio sx={{ color: "#a4243d !important" }} />
                            }
                            label={
                              <Box
                                sx={{
                                  fontSize: "14px",
                                  color: "#404040",
                                  fontFamily: "RobotoSlab",
                                  width: "250px",
                                }}
                              >
                                <Box sx={{ fontFamily: "RobotoSlabBold" }}>
                                  {address.userName} 
                                </Box>
                                <Box sx={{ fontSize: "12px" }}>
                                  {address.houseDetails},{" "}
                                  {address.streetDetails}
                                </Box>
                                <Box sx={{ fontSize: "12px" }}>
                                  {address.landmark}
                                </Box>
                                <Box sx={{ fontSize: "12px" }}>
                                  {address.pincode}
                                </Box>
                              </Box>
                            }
                          />
                        </Box>
                      </Box>
                    )
                  })}
                </RadioGroup>

                {showNewAddress ? (
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Box sx={{ mt: 2, mb: 2 }}>Add New address</Box>

                    <Box
                      sx={{
                        padding: "10px",
                        background: "#FFF5E8",
                        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
                        borderRadius: "5px",
                      }}
                    >
                      <form onSubmit={handleSubmit(onFormSubmit)}>
                        <Autocomplete
                          onLoad={onAutoCompleteLoad}
                          onPlaceChanged={onPlaceChanged}
                        >
                          <input
                            type="text"
                            placeholder="Search for your location"
                            style={{
                              boxSizing: `border-box`,
                              border: `1px solid transparent`,
                              width: `100%`,
                              height: `40px`,
                              padding: `0 12px`,
                              borderRadius: `3px`,
                              boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                              fontSize: `14px`,
                              marginBottom: "20px",
                              outline: `none`,
                              textOverflow: `ellipses`,
                            }}
                          />
                        </Autocomplete>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => printCurrentPosition()}
                          disabled={isLocating}
                        >
                          {isLocating ? "Locating..." : "Use Current Location"}
                        </Button>
                        <Box mb={3} mt={2}>
                          {isLoaded ? (
                            <GoogleMap
                              mapContainerStyle={containerStyle}
                              onLoad={onLoad}
                              zoom={10}
                              center={window["currentLocation"]}
                              options={{
                                mapTypeControl: false,
                                fullscreenControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                minZoom: 8,
                              }}
                              onUnmount={onUnmount}
                            >
                              <Marker
                                position={window["currentLocation"]}
                                draggable={true}
                                onDrag={(e) => mapPositionChanged(e.latLng)}
                              />
                            </GoogleMap>
                          ) : (
                            <></>
                          )}
                        </Box>

                        <Box mb={3}>
                          <TextField
                            label="Full Name"
                            variant="outlined"
                            fullWidth
                            defaultValue={newAddressDetail.userName}
                            name="userName"
                            {...register("userName", {
                              required: "Required field",
                            })}
                            error={Boolean(errors?.userName)}
                            helperText={errors?.userName?.message}
                          />
                        </Box>

                        <Box mb={3}>
                          <TextField
                            label="Flat, House no, Apartment"
                            variant="outlined"
                            fullWidth
                            defaultValue={newAddressDetail.houseDetails}
                            name="houseDetails"
                            {...register("houseDetails", {
                              required: "Required field",
                            })}
                            error={Boolean(errors?.houseDetails)}
                            helperText={errors?.houseDetails?.message}
                          />
                        </Box>

                        <Box mb={3}>
                          <TextField
                            label="Area, Street, City"
                            variant="outlined"
                            fullWidth
                            defaultValue={newAddressDetail.streetDetails}
                            name="streetDetails"
                            {...register("streetDetails", {
                              required: "Required field",
                            })}
                            error={Boolean(errors?.streetDetails)}
                            helperText={errors?.streetDetails?.message}
                          />
                        </Box>

                        <Box mb={3}>
                          <TextField
                            placeholder="Enter Landmark"
                            label="Landmark"
                            variant="outlined"
                            fullWidth
                            defaultValue={newAddressDetail.landmark}
                            name="landmark"
                            {...register("landmark", {
                              required: "Required field",
                            })}
                            error={Boolean(errors?.landmark)}
                            helperText={errors?.landmark?.message}
                          />
                        </Box>

                        <Box mb={3}>
                          <TextField
                            label="Pincode"
                            ariant="outlined"
                            fullWidth
                            defaultValue={newAddressDetail.pincode}
                            name="pincode"
                            {...register("pincode", {
                              required: "Required field",
                              pattern: {
                                value: /^[1-9][0-9]{5}$/,
                                message:
                                  "Invalid pincode. Pincode must be 6 digits",
                              },
                            })}
                            error={Boolean(errors?.pincode)}
                            helperText={errors?.pincode?.message}
                          />
                        </Box>

                        <Button
                          onClick={() => closeAddNewAddrForm()}
                          sx={{ mr: 2 }}
                          variant="outlined"
                        >
                          Cancel
                        </Button>
                        <Button type="submit" variant="contained">
                          Save
                        </Button>
                      </form>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ marginTop: "10px" }}>
                    <Button
                      onClick={() => setShowNewAddress(true)}
                      variant="contained"
                      size="small"
                      startIcon={
                        <img
                          src={AddIcon}
                          alt="Add Address"
                          style={{ width: "15px", height: "15px" }}
                        />
                      }
                    >
                      Add New address
                    </Button>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  mb: 1,
                  mt: 4,
                  fontSize: "20px",
                  fontFamily: "Foregen",
                  color: "#a4243d",
                }}
              ></Box>
              <Box
                sx={{
                  padding: "0px",
                  background: "#FFF5E8",
                  borderRadius: "5px",
                }}
              >
                <Select
                  placeholder="Delivery Type"
                  size="small"
                  displayEmpty
                  value={delType}
                  style={{
                    background: "#fff0d9",
                    fontWeight: "500",
                    width: "80%",
                    fontSize: "14px",
                    fontFamily: "RobotoSlab",
                  }}
                  onChange={(e) => changeDeliveryType(e)}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        bgcolor: "#fff0d9",
                        color: "black",
                        "& .MuiMenuItem-root": {
                          "&:hover": {
                            bgcolor: "#a4243d",
                            color: "#fff0d9",
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    Select Delivery Type
                  </MenuItem>
                  <MenuItem
                    key="delivery"
                    value="delivery"
                    sx={{
                      justifyContent: "space-between",
                      fontFamily:'RobotoSlab',
                      fontSize: "14px",
                    }}
                  >
                    Home delivery
                  </MenuItem>
                  {/* <MenuItem
 key="express_delivery"
 value="Express delivery"
 sx={{
 justifyContent: "space-between",
 }}
 >
 <span>Express delivery <span style={{fontSize:'9px'}}>{'(90 mins)'}</span></span> <span>₹{(deliveryCharge?.charge ?? 0) + 55}</span>
 </MenuItem> */}
                  {enableSelfPickup ? (
                    <MenuItem
                      key="self_pickup"
                      value="self_pickup"
                      sx={{
                        justifyContent: "space-between",
                        fontFamily:'RobotoSlab',
                        fontSize: "14px",
                      }}
                    >
                     Self pickup - at store
                    </MenuItem>
                  ) : null}
                </Select>
              </Box>
              <Box
                sx={{
                  fontSize: "10px",
                  fontWeight: "400",
                  marginBottom: "5px",
                  marginTop: "10px",
                  fontFamily:'RobotoSlab'
                }}
              >
                Your order will be delivered from{" "}
                <span style={{ color: "#a4243d" }}>
                  {storeDetails.storeName} store
                </span>
              </Box>

              <Box
                sx={{
                  mb: 1,
                  fontSize: "14px",
                  color: "#2C2C2C",
                  mt: 4,
                  fontFamily: "RobotoSlabBold",
                }}
              >
                Select Delivery Slot
              </Box>

              <Box
                  mb={3}
                  sx={{
                    padding: "16px 5px",
                    background: "#a4243d",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
                    borderRadius: "5px",
                    fontFamily: "RobotoSlab",
                  }}
                >
                              {/* Today/Tomorrow toggle buttons */}
                              <Box sx={{ display: "flex", mb: 2, justifyContent: "center" }}>
                            <ToggleButtonGroup
                              value={delDate}
                              exclusive
                              onChange={onDelDateChange}
                              sx={{
                                gap: "10px",
                                "& .MuiToggleButtonGroup-grouped": {
                                  borderRadius: "5px !important",
                                },
                              }}
                            >
                              <ToggleButton
                                sx={{
                                  textTransform: "none",
                                  padding: "6px 20px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color:
                                    delDate === "Today"
                                      ? "#a4243d !important"
                                      : "rgba(255, 246, 233, 1) !important",
                                  background:
                                    delDate === "Today"
                                      ? "rgba(255, 246, 233, 1) !important"
                                      : "#a4243d !important",
                                  border: "1px solid #FFF5E8 !important", // Always show border
                                  borderRadius: "5px !important",
                                  fontFamily: "RobotoSlab",
                                  minWidth: "100px",
                                }}
                                value="Today"
                              >
                                Today
                              </ToggleButton>
                              <ToggleButton
                                sx={{
                                  textTransform: "none",
                                  padding: "6px 20px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color:
                                    delDate === "Tomorrow"
                                      ? "#a4243d !important"
                                      : "#FFF5E8 !important",
                                  background:
                                    delDate === "Tomorrow"
                                      ? "#FFF5E8 !important"
                                      : "#a4243d !important",
                                  border: "1px solid #FFF5E8 !important", // Always show border
                                  borderRadius: "5px !important",
                                  fontFamily: "RobotoSlab",
                                  minWidth: "100px",
                                }}
                                value="Tomorrow"
                              >
                                Tomorrow
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Box>

                {filteredSlots && filteredSlots.length > 0 ? (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: {
                          xs: "8px",
                          sm: "10px",
                          md: "10px",
                        },
                        width: "calc(100% - 20px)", // Subtract padding
                        mx: "auto", // Center the grid
                        px: {
                          xs: "8px",
                          sm: "12px",
                          md: "15px",
                        },
                      }}
                    >
                     {filteredSlots.map((item) => (
                        <Box
                          key={item.id}
                          onClick={() =>
                            !item.isDisabled && changeDeliverySlot(item.id)
                          }
                          sx={{
                            padding: "6px 0px",
                            borderRadius: "5px",
                            textAlign: "center",
                            cursor: item.isDisabled ? "default" : "pointer",
                            backgroundColor:
                              delSlot === item.id ? "#FFF0D9" : "transparent",
                            color: item.isDisabled
                              ? "rgba(255, 240, 217, 0.4)"
                              : delSlot === item.id
                              ? "#000"
                              : "#FFF0D9",
                            border: "1px solid",
                            borderColor: item.isDisabled
                              ? "rgba(255, 240, 217, 0.2)"
                              : "#FFF0D9",
                            opacity: item.isDisabled ? 0.6 : 1,
                            fontFamily: "RobotoSlab",
                            fontWeight: "bold",
                            fontSize: "10px", // Reduced from 12px to 10px
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor:
                                !item.isDisabled && delSlot !== item.id
                                  ? "rgba(255, 240, 217, 0.1)"
                                  : undefined,
                            },
                          }}
                        >
                          {item.displayTime}
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        color: "#FFF0D9",
                        fontFamily: "RobotoSlab",
                        fontSize: "13px",
                      }}
                    >
                      {!deliveryAddress || !storeDetails?.branchId
                        ? "Please select an address to view delivery slots"
                        : "Loading time slots..."}
                    </Box>
                  )}
              </Box>

            {/* Payment Section */}
                  <Box
                    sx={{
                      fontSize: "14px",
                      color: "#000",
                      margin: "5px",
                      fontFamily:"RobotoSlabBold"
                    }}
                  >
                    Payment Mode
                  </Box>

                  <Box
                    sx={{
                      mb: 3,
                      ml: 2,
                      background: "#FFF5E8",
                      borderRadius: "5px",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <FormControl
                      onChange={handlePaymentChange}
                      style={{ width: "max-content" }}
                    >
                      <RadioGroup defaultValue="online" sx={{ color: "#FFF5E8" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 3,
                            background: "#FFF5E8",
                            borderRadius: "5px",
                            fontFamily:'RobotoSlab'
                          }}
                        >
                          {/* Online Payment Option */}
                          <PaymentOption
                            value="online"
                            label="Online Payment"
                            isSelected={paymentMode === "online"}
                          />

                          {/* Cash On Delivery Option */}
                          {!(hasCoupon || delType === "self_pickup") && (
                            <PaymentOption
                              value="cod"
                              label="Cash On Delivery"
                              isSelected={paymentMode === "cod"}
                            />
                          )}
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>

            {/* {paymentMode === "cod" && (
              <Box
                sx={{
                  backgroundColor: "#FFF5E8",
                  padding: "8px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  marginTop:"-20px"
                }}
              >
                <Box
                  sx={{
                    fontFamily: "RobotoSlab",
                    fontSize: "9px", 
                    lineHeight: "1.4",
                    color: "#000",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      color: "#a4243d",
                      fontWeight: "bold",
                    }}
                  >
                    Note:
                  </Box>{" "}
                  ₹20 handling fee will apply for COD orders.
                  <br />
                  Don't spend extra! Avoid the ₹20 COD fee by choosing Online
                  Payment.
                </Box>
              </Box>
            )} */}
            </Box>
            <Box
              sx={{
                backgroundColor: "#a4243d",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                position: "relative",
                padding: "20px",
                margin:'0px 20px',
                borderRadius:'5px',
                marginBottom:'20px'
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#a4243d",
                  alignItems: "center",
                }}
              >
                <Button
                  onClick={() => confirmOrder()}
                  variant="outlined"
                  fullWidth
                  style={{
                    background: "#fff5e8",
                    fontFamily:'RobotoSlab',
                    fontWeight:'bold'
                  }}
                >
                    Proceed to Summary
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </motion.div>
  )
}

export default Delivery
